// ---------------------------------------------------------------------------
// AUTO-AFFILIATE (Skimlinks) CONFIG
// ---------------------------------------------------------------------------
// This powers the Materials & Tools shop and the "Where to buy" buttons on the
// calculators. Skimlinks automatically turns outbound links to supported UK
// retailers (Toolstation, Travis Perkins, B&Q, Wickes, ManoMano, Screwfix …)
// into commission-earning links — one script, no per-shop admin.
//
// IMPORTANT: This is DELIBERATELY SEPARATE from the second-hand Marketplace
// affiliate IDs (eBay / Facebook Marketplace / AutoTrader / Gumtree), which are
// configured in the BACKEND .env. Do not mix them.
//
// SETUP (one-off): create a free Skimlinks publisher account, get approved,
// copy your Publisher ID (a number, e.g. "123456X1a2b3c4...") and paste it below.
// While this is empty, no affiliate script loads and every shop link behaves as
// a normal outbound link — so the shop is fully usable in "demo" mode right now.
export const SKIMLINKS_PUBLISHER_ID = '306826X1795092';

export const AFFILIATE_ENABLED = Boolean(SKIMLINKS_PUBLISHER_ID);
